import React from "react";
import { connect } from "react-redux";
import ZeeTable from "components/ZeeTable";

import StockSupplierPriceService from "services/stock-supplier-price";

import {
  updateSupplierPrice,
  createSupplierPrice,
  removeSupplierPrice,
} from "reducers/stock";

import { setBreadcrumbs } from "reducers/view";

class StockItem extends React.Component {
  stockSupplierPriceService = new StockSupplierPriceService();

  constructor() {
    super(...arguments);
    const breadcrumbs = [
      { name: "Stock", slug: "/stock" },
      {
        name: `Item: ${this.currentItem.name}`,
        slug: `/stock/${this.currentId}`,
      },
    ];

    if (this.currentStockSupplier) {
      const { name } = this.props.supplier.find(
        (item) => item.id === this.currentStockSupplier.supplier_id
      );

      breadcrumbs.push({
        name: `Supplier: ${name}`,
        slug: `/stock/${this.currentId}/supplier/${this.currentStockSupplierId}`,
      });
    }

    this.props.setBreadcrumbs(breadcrumbs);
  }

  columns = {
    quantity: { name: "Quantity" },
    price: { name: "Price" },
    pricePerUnit: {
      name: "Price p/unit",
      noEdit: true,
      format: (pricePerUnit, row) => {
        return (row.price / row.quantity).toFixed(4);
      },
    },
  };

  get currentId() {
    return this.props.match.params.id ?? null;
  }

  get currentSupplierId() {
    return this.props.match.params.supplier_id ?? null;
  }

  get currentStockSupplier() {
    return this.props.stockSupplier.find(
      (item) =>
        item.stock_id === this.currentId &&
        item.supplier_id === this.currentSupplierId
    );
  }

  get currentStockSupplierId() {
    return this.currentStockSupplier?.id ?? null;
  }

  get currentItem() {
    return this.props.stock.find((item) => item.id === this.currentId);
  }

  get currentSupplier() {
    return this.props.supplier.find(
      (item) => item.id === this.currentSupplierId
    );
  }

  get data() {
    return this.props.stockSupplierPrice.filter(
      (item) => item.stock_supplier_id === this.currentStockSupplierId
    );
  }

  async onDelete(stock) {
    const result = await this.stockSupplierPriceService
      .delete(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.removeSupplierPrice(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(stock) {
    const result = await this.stockSupplierPriceService
      .update(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.updateSupplierPrice(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(stock) {
    stock = { ...stock, stock_supplier_id: this.currentStockSupplierId };

    const result = await this.stockSupplierPriceService
      .create(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.createSupplierPrice(result.data);
      return result.data;
    }
    return false;
  }

  render() {
    const stock = this.currentItem;
    const supplier = this.currentSupplier;

    if (this.currentItem && this.currentStockSupplier) {
      return (
        <React.Fragment>
          <h1>
            {stock.name} from {supplier.name}
          </h1>
          <ZeeTable
            title="Prices"
            columns={this.columns}
            data={this.data}
            hasSort={true}
            orderBy="quantity"
            hasAdd={true}
            hasDelete={true}
            hasEdit={true}
            onEdit={(stock) => this.onEdit(stock)}
            onDelete={(stock) => this.onDelete(stock)}
            onAdd={(stock) => this.onAdd(stock)}
          />
        </React.Fragment>
      );
    }

    /*
     */

    return (
      <p>
        In order to add add prices against a supplier, you have to assign the
        supplier to the stock item.
      </p>
    );
  }
}

export default connect(
  (state) => {
    return {
      stock: state.stock.all,
      stockSupplier: state.stock.supplier.all,
      stockSupplierPrice: state.stock.supplier.price.all,
      supplier: state.supplier.all,
    };
  },
  {
    updateSupplierPrice,
    createSupplierPrice,
    removeSupplierPrice,
    setBreadcrumbs,
  }
)(StockItem);
